import { useTranslation } from 'react-i18next';

const   ErrorMapperRegisterLogin = ({ errorCode }) => {
  const { t } = useTranslation();

  const errorMap = {
    UNAUTHORIZED: t('unauthorized.title1'),
    EMAIL_ALREADY_EXIST: t('emailError.USER_ALREADY_IN_USE'),
    USER_NOT_FOUND: t('userError.USER_NOT_FOUND'),
    USER_DISABLED: t('emailError.USER_DISABLED'),
    USER_DELETED: t('emailError.USER_DELETED'),
    USERNAME_ALREADY_EXISTS: t('usernameAlreadyInUse'),
  };

  return errorMap[errorCode] || t('emailError.DEFAULT');
};

export default ErrorMapperRegisterLogin;
